import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2cd249f0 from 'nuxt_plugin_plugin_2cd249f0' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_39afd83c from 'nuxt_plugin_sentryserver_39afd83c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7d6ea25a from 'nuxt_plugin_sentryclient_7d6ea25a' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_2e84f434 from 'nuxt_plugin_plugin_2e84f434' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_gtm_0b23ef18 from 'nuxt_plugin_gtm_0b23ef18' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_serviceauthssrserver_09764277 from 'nuxt_plugin_serviceauthssrserver_09764277' // Source: ./firebase/service.auth.ssr-server.js (mode: 'server')
import nuxt_plugin_index_ae3d31a0 from 'nuxt_plugin_index_ae3d31a0' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_serviceauthinitialize_59907505 from 'nuxt_plugin_serviceauthinitialize_59907505' // Source: ./firebase/service.auth.initialize.js (mode: 'all')
import nuxt_plugin_pluginutils_6989dbdd from 'nuxt_plugin_pluginutils_6989dbdd' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_36fa3430 from 'nuxt_plugin_pluginrouting_36fa3430' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7dda0e87 from 'nuxt_plugin_pluginmain_7dda0e87' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_7823521e from 'nuxt_plugin_axios_7823521e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_googleanalytics_458e2748 from 'nuxt_plugin_googleanalytics_458e2748' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_appcheck_28299e0f from 'nuxt_plugin_appcheck_28299e0f' // Source: ../plugins/app-check.js (mode: 'client')
import nuxt_plugin_setup_a554d764 from 'nuxt_plugin_setup_a554d764' // Source: ../plugins/setup.js (mode: 'all')
import nuxt_plugin_grecaptcha_55d867ba from 'nuxt_plugin_grecaptcha_55d867ba' // Source: ../plugins/grecaptcha.js (mode: 'all')
import nuxt_plugin_customError_18af7474 from 'nuxt_plugin_customError_18af7474' // Source: ../plugins/customError.js (mode: 'all')
import nuxt_plugin_vueclipboard_dd908108 from 'nuxt_plugin_vueclipboard_dd908108' // Source: ../plugins/vue-clipboard.js (mode: 'all')
import nuxt_plugin_globalcomponents_54ec6fe8 from 'nuxt_plugin_globalcomponents_54ec6fe8' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_vueeasyloading_b31265aa from 'nuxt_plugin_vueeasyloading_b31265aa' // Source: ../plugins/vue-easy-loading.js (mode: 'all')
import nuxt_plugin_vuesocialsharing_1108e800 from 'nuxt_plugin_vuesocialsharing_1108e800' // Source: ../plugins/vue-social-sharing.js (mode: 'all')
import nuxt_plugin_vuemask_22986860 from 'nuxt_plugin_vuemask_22986860' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_keycloackinitclient_138bf566 from 'nuxt_plugin_keycloackinitclient_138bf566' // Source: ../plugins/keycloack-init.client.js (mode: 'client')
import nuxt_plugin_idlevue_50910f54 from 'nuxt_plugin_idlevue_50910f54' // Source: ../plugins/idle-vue.js (mode: 'client')
import nuxt_plugin_vuehtml2pdf_796dc3f4 from 'nuxt_plugin_vuehtml2pdf_796dc3f4' // Source: ../plugins/vue-html2pdf (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"es"},"titleTemplate":"%s","title":"Luján de Cuyo","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Ffirebasestorage.googleapis.com\u002Fv0\u002Fb\u002Fdemosburg-dev.appspot.com\u002Fo\u002Fbrand%2Fimages%2Fempty_icon.png?alt=media&token=4964eaed-f142-4083-9aaf-bfd4c7790449"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"src":"https:\u002F\u002Fsdk.mercadopago.com\u002Fjs\u002Fv2"},{"src":"https:\u002F\u002Fresources.openpay.mx\u002Flib\u002Fopenpay-js\u002F1.2.38\u002Fopenpay.v1.min.js"},{"src":"https:\u002F\u002Fjs.openpay.mx\u002Fopenpay-data.v1.min.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('G-D61BYMJC3W')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=G-D61BYMJC3W&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2cd249f0 === 'function') {
    await nuxt_plugin_plugin_2cd249f0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_39afd83c === 'function') {
    await nuxt_plugin_sentryserver_39afd83c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7d6ea25a === 'function') {
    await nuxt_plugin_sentryclient_7d6ea25a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2e84f434 === 'function') {
    await nuxt_plugin_plugin_2e84f434(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_0b23ef18 === 'function') {
    await nuxt_plugin_gtm_0b23ef18(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_serviceauthssrserver_09764277 === 'function') {
    await nuxt_plugin_serviceauthssrserver_09764277(app.context, inject)
  }

  if (typeof nuxt_plugin_index_ae3d31a0 === 'function') {
    await nuxt_plugin_index_ae3d31a0(app.context, inject)
  }

  if (typeof nuxt_plugin_serviceauthinitialize_59907505 === 'function') {
    await nuxt_plugin_serviceauthinitialize_59907505(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_6989dbdd === 'function') {
    await nuxt_plugin_pluginutils_6989dbdd(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_36fa3430 === 'function') {
    await nuxt_plugin_pluginrouting_36fa3430(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7dda0e87 === 'function') {
    await nuxt_plugin_pluginmain_7dda0e87(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7823521e === 'function') {
    await nuxt_plugin_axios_7823521e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_458e2748 === 'function') {
    await nuxt_plugin_googleanalytics_458e2748(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appcheck_28299e0f === 'function') {
    await nuxt_plugin_appcheck_28299e0f(app.context, inject)
  }

  if (typeof nuxt_plugin_setup_a554d764 === 'function') {
    await nuxt_plugin_setup_a554d764(app.context, inject)
  }

  if (typeof nuxt_plugin_grecaptcha_55d867ba === 'function') {
    await nuxt_plugin_grecaptcha_55d867ba(app.context, inject)
  }

  if (typeof nuxt_plugin_customError_18af7474 === 'function') {
    await nuxt_plugin_customError_18af7474(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclipboard_dd908108 === 'function') {
    await nuxt_plugin_vueclipboard_dd908108(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_54ec6fe8 === 'function') {
    await nuxt_plugin_globalcomponents_54ec6fe8(app.context, inject)
  }

  if (typeof nuxt_plugin_vueeasyloading_b31265aa === 'function') {
    await nuxt_plugin_vueeasyloading_b31265aa(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharing_1108e800 === 'function') {
    await nuxt_plugin_vuesocialsharing_1108e800(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_22986860 === 'function') {
    await nuxt_plugin_vuemask_22986860(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_keycloackinitclient_138bf566 === 'function') {
    await nuxt_plugin_keycloackinitclient_138bf566(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_idlevue_50910f54 === 'function') {
    await nuxt_plugin_idlevue_50910f54(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehtml2pdf_796dc3f4 === 'function') {
    await nuxt_plugin_vuehtml2pdf_796dc3f4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
